export default "__VITE_ASSET__BfZ1ERm9__"